import { resolveFotoUrl } from './presentacionClienteShared';

/**
 * Convierte un enlace de YouTube en URL de embed (sin autoplay forzado; el navegador en TV suele permitir play con controles).
 */
export function youtubeEmbedUrlFromLink(url) {
  if (!url || typeof url !== 'string') return '';
  const s = url.trim();
  if (!s) return '';
  if (s.includes('youtube.com/embed/')) {
    const i = s.indexOf('/embed/');
    const rest = s.slice(i + '/embed/'.length).split(/[?&#]/)[0];
    return rest ? `https://www.youtube.com/embed/${rest}?rel=0` : '';
  }
  try {
    const u = new URL(s.startsWith('http') ? s : `https://${s}`);
    const host = u.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') {
      const id = u.pathname.replace(/^\//, '').split('/')[0];
      return id ? `https://www.youtube.com/embed/${id}?rel=0` : '';
    }
    if (host.includes('youtube.com')) {
      const v = u.searchParams.get('v');
      if (v) return `https://www.youtube.com/embed/${v}?rel=0`;
      const m = u.pathname.match(/\/embed\/([^/?]+)/);
      if (m) return `https://www.youtube.com/embed/${m[1]}?rel=0`;
      const sh = u.pathname.match(/\/shorts\/([^/?]+)/);
      if (sh) return `https://www.youtube.com/embed/${sh[1]}?rel=0`;
    }
  } catch {
    /* ignorar */
  }
  return '';
}

/**
 * @param {{ tipo?: string, url?: string }} row Fila de propiedad_videos
 * @returns {{ kind: 'youtube', embedUrl: string } | { kind: 'file', src: string } | null}
 */
export function resolveVideoForPresentacion(row) {
  if (!row?.url) return null;
  const tipo = String(row.tipo || 'youtube').toLowerCase();
  if (tipo === 'archivo' || tipo === 'file' || tipo === 'mp4') {
    const src = resolveFotoUrl({ url: row.url });
    return src ? { kind: 'file', src } : null;
  }
  const embedUrl = youtubeEmbedUrlFromLink(row.url);
  return embedUrl ? { kind: 'youtube', embedUrl } : null;
}

export function videosPlayables(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.filter((r) => resolveVideoForPresentacion(r));
}
